<div
  *ngIf="section"
  class="collection-products"
  [ngClass]="{
    pagination: section.pagination,
    'full-width': section.fullScreen,
    'two-columns': !section.fullScreen
  }"
  [style.marginTop.px]="marginService.getCurrentMargin(margin)"
>
  <div class="left-side" *ngIf="!section.fullScreen">
    <p class="collection-name">{{ section.name }}</p>
    <h3 class="collection-header">{{ section.header }}</h3>
    <div class="success-link desktop">
      <a class="text-link" [href]="section.headingLink">{{
        section.headingLinkDescription
      }}</a>
    </div>
  </div>
  <div class="success-link mobile">
    <a class="text-link" [href]="section.headingLink">{{
      section.headingLinkDescription
    }}</a>
  </div>
  <div
    class="right-side"
    [ngClass]="{
      'product-slider-wrapper':
        type === 'ProductSliderSection' || type === 'CollectionProductsSection'
    }"
  >
    <app-product-slider
      [products]="{ link: section.sliderLink }"
      [navigation]="section.navigation ? [1,1,1,1] : [0,0,0,0]"
      [pagination]="section.pagination ? [2,2,1,1] : [0,0,0,0]"
      [spaceBetween]="section.fullScreen ? [30, 120, 150, 203] : null"
      [height]="[242, 242, 290]"
      [width]="[180, 180, 215]"
      [sliderBefore]="
        type === 'ProductSliderSection' && section.fullScreen
          ? [12, 24, 48, 128]
          : [12, 0, 0, 0]
      "
      [slidesPerView]="section.fullScreen ? [1, 2, 2, 4] : [1, 2, 2, 3]"
    ></app-product-slider>
  </div>
</div>
